import AppStatusIncidents from '@src/main/modules/app_status/ui/components/AppStatusIncidents';

const AppStatusPage = () => <AppStatusIncidents />;

export default AppStatusPage;
